module.exports = __webpack_public_path__ + "img/product-variation.8e595eac.jpg";